export default __webpack_public_path__ + "static/media/perfect_shape_logo.95df2aea.png";